import { AlarmClock, MessageSquareText, Moon, PhoneCall, Zap } from "lucide-react";

import { daysSince, euros, frDate, initials, isDormant, isOverdue, STATUS_LABELS } from "@/components/pipeline/utils";

const ago = (iso) => {
  if (!iso) return "—";
  const d = daysSince(iso);
  return d <= 0 ? "aujourd'hui" : d === 1 ? "hier" : `il y a ${d} j`;
};

const Fact = ({ icon: Icon, label, value, testid }) => (
  <span className="pl-fact" title={label} data-testid={testid}><Icon size={11} /> <em>{label}</em> {value}</span>
);

export const LeadCard = ({ lead, tone, dormantDays, onOpen }) => {
  const overdue = isOverdue(lead);
  const dormant = isDormant(lead, dormantDays);
  return (
    <article
      className={`pl-card pl-t--${lead.status === "won" ? "won" : tone || "plain"}${overdue ? " is-overdue" : ""}`}
      onClick={() => onOpen(lead.lead_id)}
      data-deal=""
      data-lift=""
      data-lead-id={lead.lead_id}
      data-flip-id={`card-${lead.lead_id}`}
      data-testid={`pipeline-card-${lead.lead_id}`}
    >
      <div className="pl-face">
        <div className="pl-face__top">
          <span className={`pl-face__date${overdue ? " is-over" : ""}`} data-testid={lead.remind_date ? "pipeline-card-reminder-badge" : undefined}>
            {lead.remind_date ? <><AlarmClock size={12} /> {frDate(lead.remind_date)}</> : `Action ${ago(lead.updated_at)}`}
          </span>
          {lead.status !== "todo" && <span className={`pl-status s-${lead.status}`}>{STATUS_LABELS[lead.status] || lead.status}</span>}
        </div>
        <h4 className="pl-face__title pl-card-title" data-testid="pipeline-card-title">{lead.title}</h4>
        <span className="pl-face__co">{lead.owner_name || "Non attribuée"}</span>
        {lead.created_at && <span className="pl-face__arrived" data-testid="pipeline-card-arrived">Arrivé le {frDate(lead.created_at.slice(0, 10))}</span>}
        <span className="pl-face__city" data-testid="pipeline-card-city">{(lead.city ? [lead.zipcode, lead.city] : [lead.place_hint?.zipcode || lead.zipcode, lead.place_hint?.city]).filter(Boolean).join(" ")}</span>
        <div className="pl-facts">
          <Fact icon={Zap} label="Action" value={ago(lead.updated_at)} testid="pipeline-card-last-action" />
          <Fact icon={MessageSquareText} label="Comm." value={ago(lead.last_comment_at)} testid="pipeline-card-last-comment" />
          <Fact icon={PhoneCall} label="Appel" value={ago(lead.last_call_at)} testid="pipeline-card-last-call" />
          {dormant && <span className="pl-fact" data-testid="pipeline-card-dormant-badge"><Moon size={11} /> {daysSince(lead.updated_at)} j sans action</span>}
        </div>
        <div className="pl-face__foot">
          <span className="pl-face__amt" data-testid={lead.amount ? "pipeline-card-amount" : undefined}>{lead.amount ? euros(lead.amount) : ""}</span>
          <span className="av av--sm av--t1" title={lead.owner_name || "Non attribuée"}>{initials(lead.owner_name)}</span>
        </div>
      </div>
    </article>
  );
};
